// Add your custom JS here.

// ==============================
// US Phone Number Mask — (XXX) XXX-XXXX
// ==============================
(function () {
	function formatUSPhone(value) {
		var digits = value.replace(/\D/g, '');
		// Remove leading 1 if typed
		if (digits.length > 0 && digits[0] === '1') digits = digits.substring(1);
		if (digits.length > 10) digits = digits.substring(0, 10);

		if (digits.length === 0) return '';
		if (digits.length <= 3) return '(' + digits;
		if (digits.length <= 6) return '(' + digits.substring(0, 3) + ') ' + digits.substring(3);
		return '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
	}

	document.addEventListener('DOMContentLoaded', function () {
		var phoneInputs = document.querySelectorAll('.celara-phone-mask');
		phoneInputs.forEach(function (input) {
			// Format existing value on load
			if (input.value) {
				input.value = formatUSPhone(input.value);
			}

			input.addEventListener('input', function () {
				var cursorPos = input.selectionStart;
				var prevLen = input.value.length;
				input.value = formatUSPhone(input.value);
				var newLen = input.value.length;
				var newPos = cursorPos + (newLen - prevLen);
				input.setSelectionRange(newPos, newPos);
			});

			input.addEventListener('keydown', function (e) {
				// Allow backspace, delete, tab, arrows
				var allowed = [8, 46, 9, 37, 38, 39, 40];
				if (allowed.indexOf(e.keyCode) !== -1) return;
				// Allow ctrl/cmd + a/c/v/x
				if ((e.ctrlKey || e.metaKey) && [65, 67, 86, 88].indexOf(e.keyCode) !== -1) return;
				// Block non-digit keys
				var digits = input.value.replace(/\D/g, '');
				if (digits.length >= 10 && !e.ctrlKey && !e.metaKey) {
					e.preventDefault();
				}
			});

			input.addEventListener('paste', function () {
				setTimeout(function () {
					input.value = formatUSPhone(input.value);
				}, 0);
			});
		});
	});
})();

// ==============================
// Celara Checkout Multi-Step
// ==============================
(function () {
	document.addEventListener('DOMContentLoaded', function () {
		const checkoutForm = document.querySelector('.celara-checkout__form');
		if (!checkoutForm) return;

		// Step navigation
		const steps = document.querySelectorAll('.celara-checkout__step');
		const nextBtns = document.querySelectorAll('.celara-checkout__next-btn');
		const stepHeaders = document.querySelectorAll('.celara-checkout__step-header');

		function openStep(stepNum) {
			steps.forEach(function (step) {
				var num = parseInt(step.getAttribute('data-step'));
				if (num === stepNum) {
					step.classList.add('active');
				} else {
					step.classList.remove('active');
				}
			});

			// Scroll to active step
			var activeStep = document.querySelector('.celara-checkout__step[data-step="' + stepNum + '"]');

			if (activeStep) {
				setTimeout(function () {

					const offset = 120; // space from top
					const elementPosition = activeStep.getBoundingClientRect().top;
					const offsetPosition = elementPosition + window.pageYOffset - offset;

					window.scrollTo({
						top: offsetPosition,
						behavior: "smooth"
					});

				}, 100);
			}
		}

		// Remove previous error messages from a step
		function clearStepErrors(step) {
			step.querySelectorAll('.celara-field-error-msg').forEach(function (el) { el.remove(); });
			step.querySelectorAll('.celara-field-error').forEach(function (el) { el.classList.remove('celara-field-error'); });
			var banner = step.querySelector('.celara-step-error-banner');
			if (banner) banner.remove();
		}

		// Show inline error under a field
		function showFieldError(field, message) {
			field.classList.add('celara-field-error');
			var parent = field.closest('.form_controller') || field.parentElement;
			if (parent && !parent.querySelector('.celara-field-error-msg')) {
				var msg = document.createElement('span');
				msg.className = 'celara-field-error-msg';
				msg.textContent = message;
				parent.appendChild(msg);
			}
		}

		// Show a banner error at top of step content
		function showStepBanner(step, message) {
			var content = step.querySelector('.celara-checkout__step-content');
			if (!content) return;
			var existing = content.querySelector('.celara-step-error-banner');
			if (existing) existing.remove();
			var banner = document.createElement('div');
			banner.className = 'celara-step-error-banner';
			banner.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm.5 10.5h-1v-1h1v1zm0-2h-1v-5h1v5z" fill="currentColor"/></svg> ' + message;
			content.insertBefore(banner, content.firstChild);
		}

		// Get label text for a field
		function getFieldLabel(field) {
			var parent = field.closest('.form_controller') || field.parentElement;
			if (parent) {
				var label = parent.querySelector('label');
				if (label) return label.textContent.trim();
			}
			return field.name || 'This field';
		}

		// Validate fields in a step
		function validateStep(stepNum) {
			var step = document.querySelector('.celara-checkout__step[data-step="' + stepNum + '"]');
			if (!step) return true;

			clearStepErrors(step);
			var isValid = true;
			var missingFields = [];

			// Step 1: Personal & Contact Information
			if (stepNum === 1) {
				var requiredFields = step.querySelectorAll('input[required], select[required]');
				requiredFields.forEach(function (field) {
					if (!field.value.trim()) {
						var label = getFieldLabel(field);
						showFieldError(field, label + ' is required');
						missingFields.push(label);
						isValid = false;
					}
				});

				// Email format validation
				var emailField = step.querySelector('#billing_email');
				if (emailField && emailField.value.trim()) {
					var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (!emailPattern.test(emailField.value)) {
						showFieldError(emailField, 'Please enter a valid email address');
						missingFields.push('Valid Email');
						isValid = false;
					}
				}

				// DOB fields (not required in HTML but should be validated)
				var dobMonth = step.querySelector('#celara_dob_month');
				var dobDay = step.querySelector('#celara_dob_day');
				var dobYear = step.querySelector('#celara_dob_year');
				var gender = step.querySelector('#celara_gender');

				if (dobMonth && !dobMonth.value) {
					showFieldError(dobMonth, 'Month is required');
					missingFields.push('Month');
					isValid = false;
				}
				if (dobDay && !dobDay.value) {
					showFieldError(dobDay, 'Date is required');
					missingFields.push('Date');
					isValid = false;
				}
				if (dobYear && !dobYear.value) {
					showFieldError(dobYear, 'Year is required');
					missingFields.push('Year');
					isValid = false;
				}
				if (gender && !gender.value) {
					showFieldError(gender, 'Gender is required');
					missingFields.push('Gender');
					isValid = false;
				}
			}

			// Step 2: Shipping Details
			if (stepNum === 2) {
				var shipToBillingChk = step.querySelector('#ship_to_billing');
				if (shipToBillingChk && !shipToBillingChk.checked) {
					// Shipping fields are visible, validate them
					var shippingInputs = step.querySelectorAll('#celara-shipping-fields input[type="text"]');
					shippingInputs.forEach(function (field) {
						// Skip address line 2 (optional) and hidden fields
						if (field.name === 'shipping_address_2' || field.type === 'hidden') return;
						if (!field.value.trim()) {
							var label = getFieldLabel(field);
							showFieldError(field, label + ' is required');
							missingFields.push(label);
							isValid = false;
						}
					});
				}
			}

			// Step 3: Acknowledgement
			if (stepNum === 3) {
				var requiredCheckboxes = step.querySelectorAll('input[type="checkbox"][required]');
				requiredCheckboxes.forEach(function (cb) {
					if (!cb.checked) {
						var checkboxLabel = cb.closest('.celara-checkout__checkbox');
						if (checkboxLabel) {
							checkboxLabel.classList.add('celara-field-error');
							var textEl = checkboxLabel.querySelector('.celara-checkout__checkbox-text');
							var shortText = textEl ? textEl.textContent.substring(0, 50) + '...' : 'This agreement';
							missingFields.push(shortText);
						}
						isValid = false;
					}
				});
			}

			// Step 4: Secure Payment
			if (stepNum === 4) {
				// Check payment type is selected
				var paymentSelected = step.querySelector('input[name="celara_payment_type"]:checked');
				if (!paymentSelected) {
					missingFields.push('Payment Type');
					isValid = false;
				}

				// If installments selected, check provider
				if (paymentSelected && paymentSelected.value === 'installments') {
					var providerSelected = step.querySelector('input[name="celara_installment_provider"]:checked');
					if (!providerSelected) {
						missingFields.push('Installment Provider (PayPal or Klarna)');
						isValid = false;
					}
				}
			}

			// Show banner with summary of missing fields
			if (!isValid) {
				var bannerMsg = 'Please fill in the following: ' + missingFields.join(', ');
				showStepBanner(step, bannerMsg);

				// Scroll to banner
				var bannerEl = step.querySelector('.celara-step-error-banner');
				if (bannerEl) {
					setTimeout(function () {
						bannerEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}, 100);
				}
			}

			return isValid;
		}

		// Next step buttons
		nextBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				var nextStep = parseInt(btn.getAttribute('data-next-step'));
				var currentStep = nextStep - 1;

				if (validateStep(currentStep)) {
					openStep(nextStep);
				}
			});
		});

		// Click on step headers to toggle (only completed steps)
		stepHeaders.forEach(function (header) {
			header.addEventListener('click', function () {
				var stepNum = parseInt(header.getAttribute('data-step-toggle'));
				var activeStep = document.querySelector('.celara-checkout__step.active');
				var activeStepNum = activeStep ? parseInt(activeStep.getAttribute('data-step')) : 1;

				// Allow clicking on completed steps (lower numbers) or current step
				if (stepNum <= activeStepNum) {
					openStep(stepNum);
				}
			});
		});

		// Promo code toggle
		var promoToggle = document.getElementById('celara-promo-toggle');
		var promoForm = document.getElementById('celara-promo-form');
		if (promoToggle && promoForm) {
			promoToggle.parentElement.addEventListener('click', function () {
				var isOpen = promoForm.style.display !== 'none';
				promoForm.style.display = isOpen ? 'none' : 'block';
				promoToggle.parentElement.classList.toggle('is-open');
			});
		}

		// Apply coupon
		var applyCouponBtn = document.getElementById('celara-apply-coupon');
		if (applyCouponBtn) {
			applyCouponBtn.addEventListener('click', function () {
				var couponCode = document.getElementById('celara-coupon-code').value;
				if (!couponCode) return;

				var data = new FormData();
				data.append('action', 'celara_apply_coupon');
				data.append('coupon_code', couponCode);
				data.append('security', typeof wc_checkout_params !== 'undefined' ? wc_checkout_params.apply_coupon_nonce : '');

				fetch(typeof wc_checkout_params !== 'undefined' ? wc_checkout_params.ajax_url : '/wp-admin/admin-ajax.php', {
					method: 'POST',
					body: data
				})
					.then(function (response) { return response.text(); })
					.then(function () {
						// Trigger WooCommerce update
						if (typeof jQuery !== 'undefined') {
							jQuery('body').trigger('update_checkout');
						}
					});
			});
		}

		// Shipping same as billing checkbox
		var shipToBilling = document.getElementById('ship_to_billing');
		var shippingFields = document.getElementById('celara-shipping-fields');
		if (shipToBilling && shippingFields) {
			shipToBilling.addEventListener('change', function () {
				shippingFields.style.display = this.checked ? 'none' : 'block';
			});
		}

		// Payment type toggle - show/hide installment providers & select WC gateway
		var paymentRadios = document.querySelectorAll('input[name="celara_payment_type"]');
		var installmentProviders = document.getElementById('celara-installment-providers');

		function selectWcGateway(gatewayId) {
			var gatewayRadio = document.getElementById('payment_method_' + gatewayId);
			if (gatewayRadio) {
				gatewayRadio.checked = true;
				gatewayRadio.click();
				// console.log('[Celara Checkout] WC gateway selected:', gatewayId);
			} else {
				console.warn('[Celara Checkout] WC gateway NOT found:', gatewayId, '- Available:', Array.from(document.querySelectorAll('#payment input[type="radio"]')).map(function (r) { return r.id; }));
			}
		}

		function syncPaymentGateway(value) {
			if (installmentProviders) {
				installmentProviders.style.display = value === 'installments' ? 'flex' : 'none';
			}
			if (value === 'cod') {
				selectWcGateway('cod');
			} else if (value === 'full') {
				selectWcGateway('ppcp-gateway');
			} else if (value === 'installments') {
				selectWcGateway('ppcp-gateway');
			} else if (value === 'test_fail') {
				selectWcGateway('celara_test_fail');
			}
		}

		if (paymentRadios.length) {
			paymentRadios.forEach(function (radio) {
				radio.addEventListener('change', function () {
					syncPaymentGateway(this.value);
				});
			});

			// Auto-select WC gateway on page load based on default checked option
			var defaultPayment = document.querySelector('input[name="celara_payment_type"]:checked');
			if (defaultPayment) {
				// Wait for WooCommerce to render payment methods, then sync
				var syncInterval = setInterval(function () {
					var wcPaymentExists = document.querySelector('#payment .wc_payment_methods input[type="radio"]');
					if (wcPaymentExists) {
						clearInterval(syncInterval);
						syncPaymentGateway(defaultPayment.value);
					}
				}, 200);
				// Safety: stop polling after 5 seconds
				setTimeout(function () { clearInterval(syncInterval); }, 5000);
			}
		}

		// Restore submit button text (WooCommerce JS overwrites it)
		var placeOrderBtn = document.getElementById('place_order');
		if (placeOrderBtn) {
			var btnHtml = 'Continue <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.5"/><path d="M10 8L14 12L10 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

			// Set initially
			placeOrderBtn.innerHTML = btnHtml;

			// Observe WooCommerce overwriting the button text
			var observer = new MutationObserver(function () {
				if (placeOrderBtn.innerHTML.indexOf('svg-wrapper') === -1) {
					placeOrderBtn.innerHTML = btnHtml;
				}
			});
			observer.observe(placeOrderBtn, { childList: true, characterData: true, subtree: true });
		}

		// Real-time: clear error on field when user starts filling it
		checkoutForm.addEventListener('input', function (e) {
			var field = e.target;
			if (field.classList.contains('celara-field-error')) {
				field.classList.remove('celara-field-error');
				var parent = field.closest('.form_controller') || field.parentElement;
				if (parent) {
					var errMsg = parent.querySelector('.celara-field-error-msg');
					if (errMsg) errMsg.remove();
				}
			}
		});

		// Clear checkbox error on change
		checkoutForm.addEventListener('change', function (e) {
			var field = e.target;
			if (field.type === 'checkbox' || field.type === 'radio') {
				var label = field.closest('.celara-checkout__checkbox, .celara-checkout__radio');
				if (label) label.classList.remove('celara-field-error');

				// Also clear field-level error
				if (field.classList.contains('celara-field-error')) {
					field.classList.remove('celara-field-error');
					var parent = field.closest('.form_controller') || field.parentElement;
					if (parent) {
						var errMsg = parent.querySelector('.celara-field-error-msg');
						if (errMsg) errMsg.remove();
					}
				}
			}
		});

		// Re-sync WC gateway after WooCommerce AJAX updates (it re-renders payment section)
		if (typeof jQuery !== 'undefined') {
			jQuery(document.body).on('updated_checkout', function () {
				var currentPayment = document.querySelector('input[name="celara_payment_type"]:checked');
				if (currentPayment) {
					syncPaymentGateway(currentPayment.value);
				}
			});

			// Show WooCommerce checkout errors inside Step 4 as a visible alert
			jQuery(document.body).on('checkout_error', function () {
				var wcErrors = document.querySelector('.woocommerce-NoticeGroup-checkout');
				if (wcErrors) {
					var errorText = wcErrors.textContent.trim();
					console.error('[Celara Checkout] WC Error:', errorText);

					// Make sure step 4 is active/visible
					openStep(4);

					// Show error banner inside step 4
					var step4 = document.querySelector('#celara-step-4');
					if (step4) {
						showStepBanner(step4, errorText);
						var bannerEl = step4.querySelector('.celara-step-error-banner');
						if (bannerEl) {
							bannerEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
						}
					}
				}
			});
		}

		// Copy billing to shipping hidden fields when "same as billing" is checked
		checkoutForm.addEventListener('submit', function () {
			if (shipToBilling && shipToBilling.checked) {
				var shippingFirstName = document.querySelector('input[name="shipping_first_name"]');
				var shippingLastName = document.querySelector('input[name="shipping_last_name"]');
				if (shippingFirstName) shippingFirstName.value = document.getElementById('billing_first_name').value;
				if (shippingLastName) shippingLastName.value = document.getElementById('billing_last_name').value;

				var billingFields = ['address_1', 'address_2', 'city', 'postcode', 'state', 'country'];
				billingFields.forEach(function (field) {
					var billingInput = document.querySelector('input[name="billing_' + field + '"]');
					var shippingInput = document.querySelector('input[name="shipping_' + field + '"]');
					if (billingInput && shippingInput) {
						shippingInput.value = billingInput.value;
					}
				});
			}
		});
		// ==============================
		// Identity Document Upload on Checkout
		// ==============================
		var identitySection = document.getElementById('celara-identity-required');
		if (identitySection) {
			var identityInput = document.getElementById('celara-checkout-identity-input');
			var browseBtn = document.getElementById('celara-checkout-browse');
			var dropzone = document.getElementById('celara-checkout-dropzone');
			var filenameEl = document.getElementById('celara-checkout-identity-filename');
			var uploadBtn = document.getElementById('celara-checkout-upload-btn');
			var placeOrderBtn = document.getElementById('place_order');

			// Disable place order until identity is uploaded
			if (placeOrderBtn) {
				placeOrderBtn.disabled = true;
				placeOrderBtn.style.opacity = '0.5';
				placeOrderBtn.style.cursor = 'not-allowed';
			}

			// Scroll to the identity section on page load
			setTimeout(function () {
				identitySection.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 500);

			// Browse click
			if (browseBtn && identityInput) {
				browseBtn.addEventListener('click', function (e) {
					e.preventDefault();
					identityInput.click();
				});
			}

			// Dropzone click
			if (dropzone && identityInput) {
				dropzone.addEventListener('click', function () {
					identityInput.click();
				});

				dropzone.addEventListener('dragover', function (e) {
					e.preventDefault();
					dropzone.classList.add('dragover');
				});
				dropzone.addEventListener('dragleave', function () {
					dropzone.classList.remove('dragover');
				});
				dropzone.addEventListener('drop', function (e) {
					e.preventDefault();
					dropzone.classList.remove('dragover');
					if (e.dataTransfer.files.length > 0) {
						identityInput.files = e.dataTransfer.files;
						identityInput.dispatchEvent(new Event('change'));
					}
				});
			}

			// File selected
			if (identityInput) {
				identityInput.addEventListener('change', function () {
					if (!identityInput.files.length) {
						filenameEl.textContent = '';
						uploadBtn.disabled = true;
						return;
					}
					var file = identityInput.files[0];
					var allowed = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
					if (allowed.indexOf(file.type) === -1) {
						alert('Please upload a PDF, DOC, or DOCX file.');
						identityInput.value = '';
						filenameEl.textContent = '';
						uploadBtn.disabled = true;
						return;
					}
					if (file.size > 25 * 1024 * 1024) {
						alert('File size must be under 25 MB.');
						identityInput.value = '';
						filenameEl.textContent = '';
						uploadBtn.disabled = true;
						return;
					}
					filenameEl.textContent = 'Selected: ' + file.name;
					uploadBtn.disabled = false;
				});
			}

			// Upload button
			if (uploadBtn) {
				uploadBtn.addEventListener('click', function () {
					if (!identityInput.files.length) return;
					uploadBtn.disabled = true;
					uploadBtn.textContent = 'Uploading...';

					var formData = new FormData();
					formData.append('action', 'celara_upload_identity_doc');
					formData.append('nonce', celaraMyAccount.nonce);
					formData.append('identity_card', identityInput.files[0]);

					fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
						.then(function (r) { return r.json(); })
						.then(function (data) {
							if (data.success) {
								// Replace the entire section with success message
								identitySection.innerHTML =
									'<div class="celara-checkout__identity-success">' +
									'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">' +
									'<path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
									'</svg>' +
									'<span>Identity document uploaded successfully. You may now proceed with your order.</span>' +
									'</div>';
								identitySection.style.background = '#eafaf1';
								identitySection.style.borderColor = '#a3d9b1';

								// Enable place order
								if (placeOrderBtn) {
									placeOrderBtn.disabled = false;
									placeOrderBtn.style.opacity = '';
									placeOrderBtn.style.cursor = '';
								}
							} else {
								alert(data.data || 'Upload failed. Please try again.');
								uploadBtn.disabled = false;
								uploadBtn.textContent = 'Upload Identity Card';
							}
						})
						.catch(function () {
							alert('Upload failed. Please try again.');
							uploadBtn.disabled = false;
							uploadBtn.textContent = 'Upload Identity Card';
						});
				});
			}
		}
	});
})();

// ==============================
// Celara My Account Portal
// ==============================
(function () {
	document.addEventListener('DOMContentLoaded', function () {
		var myAccount = document.querySelector('.celara-myaccount');
		if (!myAccount) return;

		// --- Mobile Sidebar Toggle ---
		var sidebar = document.querySelector('.celara-myaccount__sidebar');
		var overlay = document.querySelector('.celara-myaccount__overlay');
		var menuToggle = document.querySelector('.celara-myaccount__menu-toggle');

		function openSidebar() {
			if (sidebar) sidebar.classList.add('is-open');
			if (overlay) overlay.classList.add('is-visible');
			document.body.style.overflow = 'hidden';
		}
		function closeSidebar() {
			if (sidebar) sidebar.classList.remove('is-open');
			if (overlay) overlay.classList.remove('is-visible');
			document.body.style.overflow = '';
		}

		if (menuToggle) menuToggle.addEventListener('click', openSidebar);
		if (overlay) overlay.addEventListener('click', closeSidebar);

		// --- Orders Search ---
		var searchInput = document.querySelector('.celara-orders__search-input');
		var ordersTable = document.querySelector('.celara-orders__table');
		if (searchInput && ordersTable) {
			searchInput.addEventListener('input', function () {
				var query = this.value.toLowerCase();
				var rows = ordersTable.querySelectorAll('.celara-orders__row');
				rows.forEach(function (row) {
					var text = row.textContent.toLowerCase();
					row.style.display = text.indexOf(query) !== -1 ? '' : 'none';
				});
			});
		}

		// --- Orders Sort ---
		var sortBtn = document.querySelector('.celara-orders__sort-btn');
		if (sortBtn && ordersTable) {
			var sortAsc = true;
			sortBtn.addEventListener('click', function () {
				var tbody = ordersTable.querySelector('tbody') || ordersTable;
				var rows = Array.prototype.slice.call(tbody.querySelectorAll('.celara-orders__row'));
				rows.sort(function (a, b) {
					var dateA = a.querySelector('.celara-orders__date');
					var dateB = b.querySelector('.celara-orders__date');
					if (!dateA || !dateB) return 0;
					var tA = new Date(dateA.textContent.trim()).getTime() || 0;
					var tB = new Date(dateB.textContent.trim()).getTime() || 0;
					return sortAsc ? tA - tB : tB - tA;
				});
				rows.forEach(function (row) { tbody.appendChild(row); });
				sortAsc = !sortAsc;
			});
		}

		// --- Dashboard Product Carousel ---
		var carousel = document.querySelector('.celara-dashboard__carousel-track');
		var dots = document.querySelectorAll('.celara-dashboard__dot');
		if (carousel && dots.length) {
			var currentSlide = 0;
			var slides = carousel.querySelectorAll('.celara-dashboard__product-card');
			var totalSlides = slides.length;

			function goToSlide(index) {
				if (index < 0) index = 0;
				if (index >= totalSlides) index = totalSlides - 1;
				currentSlide = index;
				var offset = slides[index].offsetLeft - carousel.offsetLeft;
				carousel.scrollTo({ left: offset, behavior: 'smooth' });
				dots.forEach(function (dot, i) {
					dot.classList.toggle('is-active', i === index);
				});
			}

			dots.forEach(function (dot, i) {
				dot.addEventListener('click', function () { goToSlide(i); });
			});
		}

		// --- Avatar Upload ---
		var avatarInput = document.getElementById('celara-avatar-input');
		var avatarPreview = document.getElementById('celara-avatar-preview');
		var removeAvatarBtn = document.getElementById('celara-remove-avatar');
		var avatarUploadLabel = document.getElementById('celara-avatar-upload-label');

		// Helper to disable/enable a button or label
		function disableBtn(el) {
			if (!el) return;
			el.style.pointerEvents = 'none';
			el.style.opacity = '0.5';
			if (el.tagName === 'BUTTON') el.disabled = true;
		}
		function enableBtn(el) {
			if (!el) return;
			el.style.pointerEvents = '';
			el.style.opacity = '';
			if (el.tagName === 'BUTTON') el.disabled = false;
		}

		if (avatarInput) {
			avatarInput.addEventListener('change', function () {
				var file = this.files[0];
				if (!file) return;

				// Loading state on upload, disable remove
				if (avatarUploadLabel) {
					avatarUploadLabel.classList.add('is-loading');
					var textEl = avatarUploadLabel.querySelector('.celara-upload-text');
					if (textEl) textEl.textContent = 'Uploading...';
					var iconEl = avatarUploadLabel.querySelector('.celara-upload-icon');
					if (iconEl) iconEl.style.display = 'none';
				}
				disableBtn(removeAvatarBtn);

				var formData = new FormData();
				formData.append('action', 'celara_upload_avatar');
				formData.append('avatar', file);
				formData.append('nonce', celaraMyAccount.nonce);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (data.success && avatarPreview) {
							avatarPreview.innerHTML = '<img src="' + data.data.url + '" alt="Avatar">';
						}
						if (avatarUploadLabel) {
							avatarUploadLabel.classList.remove('is-loading');
							var textEl = avatarUploadLabel.querySelector('.celara-upload-text');
							if (textEl) textEl.textContent = 'Upload Photo';
							var iconEl = avatarUploadLabel.querySelector('.celara-upload-icon');
							if (iconEl) iconEl.style.display = '';
						}
						enableBtn(removeAvatarBtn);
					})
					.catch(function () {
						if (avatarUploadLabel) {
							avatarUploadLabel.classList.remove('is-loading');
							var textEl = avatarUploadLabel.querySelector('.celara-upload-text');
							if (textEl) textEl.textContent = 'Upload Photo';
							var iconEl = avatarUploadLabel.querySelector('.celara-upload-icon');
							if (iconEl) iconEl.style.display = '';
						}
						enableBtn(removeAvatarBtn);
					});
			});
		}

		if (removeAvatarBtn) {
			removeAvatarBtn.addEventListener('click', function () {
				// Loading state on remove, disable upload
				removeAvatarBtn.disabled = true;
				removeAvatarBtn.classList.add('is-loading');
				var rmTextEl = removeAvatarBtn.querySelector('.celara-upload-text');
				var rmIconEl = removeAvatarBtn.querySelector('.celara-upload-icon');
				if (rmTextEl) rmTextEl.textContent = 'Removing...';
				if (rmIconEl) rmIconEl.style.display = 'none';
				disableBtn(avatarUploadLabel);

				var formData = new FormData();
				formData.append('action', 'celara_remove_avatar');
				formData.append('nonce', celaraMyAccount.nonce);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (data.success && avatarPreview) {
							avatarPreview.innerHTML = '<img src="' + data.data.default + '" alt="Avatar">';
						}
						removeAvatarBtn.disabled = false;
						removeAvatarBtn.classList.remove('is-loading');
						if (rmTextEl) rmTextEl.textContent = 'Remove Photo';
						if (rmIconEl) rmIconEl.style.display = '';
						enableBtn(avatarUploadLabel);
					})
					.catch(function () {
						removeAvatarBtn.disabled = false;
						removeAvatarBtn.classList.remove('is-loading');
						if (rmTextEl) rmTextEl.textContent = 'Remove Photo';
						if (rmIconEl) rmIconEl.style.display = '';
						enableBtn(avatarUploadLabel);
					});
			});
		}

		// --- Identity Document Remove ---
		var removeDocBtn = document.getElementById('celara-remove-doc');
		var docPreview = document.getElementById('celara-doc-preview');
		var docUpload = document.getElementById('celara-doc-upload');
		if (removeDocBtn && docPreview && docUpload) {
			removeDocBtn.addEventListener('click', function () {
				if (!confirm('Remove your identity document?')) return;

				var formData = new FormData();
				formData.append('action', 'celara_remove_identity_doc');
				formData.append('nonce', celaraMyAccount.nonce);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (data.success) {
							docPreview.style.display = 'none';
							docUpload.style.display = '';
						}
					});
			});
		}

		// --- Identity Document Upload ---
		var identityInput = document.getElementById('celara-identity-input');
		var identityUploadLabel = document.getElementById('celara-identity-upload-label');
		if (identityInput) {
			identityInput.addEventListener('change', function () {
				if (!identityInput.files.length) return;
				var file = identityInput.files[0];
				var allowed = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
				if (allowed.indexOf(file.type) === -1) {
					alert('Please upload a PDF, DOC, or DOCX file.');
					identityInput.value = '';
					return;
				}
				if (file.size > 25 * 1024 * 1024) {
					alert('File size must be under 25 MB.');
					identityInput.value = '';
					return;
				}

				// Loading state
				if (identityUploadLabel) {
					identityUploadLabel.classList.add('is-loading');
					var textEl = identityUploadLabel.querySelector('.celara-upload-text');
					if (textEl) textEl.textContent = 'Uploading...';
					var iconEl = identityUploadLabel.querySelector('.celara-upload-icon');
					if (iconEl) iconEl.style.display = 'none';
				}

				var formData = new FormData();
				formData.append('action', 'celara_upload_identity_doc');
				formData.append('nonce', celaraMyAccount.nonce);
				formData.append('identity_card', file);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (data.success) {
							location.reload();
						} else {
							alert(data.data || 'Upload failed. Please try again.');
							// Reset loading state
							if (identityUploadLabel) {
								identityUploadLabel.classList.remove('is-loading');
								var textEl = identityUploadLabel.querySelector('.celara-upload-text');
								if (textEl) textEl.textContent = 'Upload Identity Card';
								var iconEl = identityUploadLabel.querySelector('.celara-upload-icon');
								if (iconEl) iconEl.style.display = '';
							}
						}
					})
					.catch(function () {
						if (identityUploadLabel) {
							identityUploadLabel.classList.remove('is-loading');
							var textEl = identityUploadLabel.querySelector('.celara-upload-text');
							if (textEl) textEl.textContent = 'Upload Identity Card';
							var iconEl = identityUploadLabel.querySelector('.celara-upload-icon');
							if (iconEl) iconEl.style.display = '';
						}
					});
			});
		}
	});
})();

// ==============================
// Complete Medical Review (Qualiphy) — runs on any page
// ==============================
(function () {
	document.addEventListener('DOMContentLoaded', function () {
		// console.log("Celara My Account: Medical Review JS Loaded");
		if (typeof celaraMyAccount === 'undefined') return;

		var reviewBtns = document.querySelectorAll('.celara-medical-review-btn');
		reviewBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				var orderId = btn.getAttribute('data-order-id');
				var examId = btn.getAttribute('data-exam-id');
				// console.log('examId: ', examId);
				if (!orderId && !examId) return;

				var originalText = btn.innerHTML;
				btn.innerHTML = 'Loading...';
				btn.style.pointerEvents = 'none';
				btn.style.opacity = '0.7';

				var formData = new FormData();
				formData.append('action', 'celara_start_medical_review');
				formData.append('order_id', orderId);
				formData.append('exam_id', examId);
				formData.append('nonce', celaraMyAccount.nonce);
				// console.log('formData: ', formData);

				// Set to false for production.
				//   │ CELARA_DEBUG_MEDICAL │ CELARA_SHOW_POPUP │                    Result                     │                                         ├──────────────────────┼───────────────────┼───────────────────────────────────────────────┤                                       
				//   │ true                 │ true              │ Popup shown, no redirect (debug)              │                                       
				//   ├──────────────────────┼───────────────────┼───────────────────────────────────────────────┤
				//   │ true                 │ false             │ No popup, no redirect (button resets)         │
				//   ├──────────────────────┼───────────────────┼───────────────────────────────────────────────┤
				//   │ false                │ true              │ Popup shown with 5s countdown, then redirects │
				//   ├──────────────────────┼───────────────────┼───────────────────────────────────────────────┤
				//   │ false                │ false             │ Immediate redirect, no popup      

				var CELARA_DEBUG_MEDICAL = false;
				var CELARA_SHOW_POPUP = true;

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						// console.log("API response:", JSON.stringify(data));
						if (data.success && data.data.meeting_url) {
							var d = data.data;

							// console.log("-------------------------------");
							// console.log("Medical review started, redirecting to:", d.meeting_url);
							// console.log("product_name:", d.product_name);
							// console.log("product_id:", d.product_id);
							// console.log("exam_name:", d.exam_name);
							// console.log("exam_id:", d.exam_id);
							// console.log("-------------------------------");

							if (CELARA_SHOW_POPUP) {
								var overlay = document.createElement('div');
								overlay.className = 'celara-redirect-overlay';
								overlay.innerHTML =
									'<div class="celara-redirect-popup">' +
									'<h3>Starting Medical Review</h3>' +
									'<div class="celara-redirect-popup__info">' +
									'<p><strong>Exam:</strong> ' + (d.exam_name || '—') + ' <span class="celara-redirect-popup__id">(ID: ' + (d.exam_id || examId) + ')</span></p>' +
									'<p><strong>Product:</strong> ' + (d.product_name || '—') + ' <span class="celara-redirect-popup__id">(ID: ' + (d.product_id || '—') + ')</span></p>' +
									'</div>' +
									(CELARA_DEBUG_MEDICAL
										? '<p class="celara-redirect-popup__meeting-url"><strong>Meeting URL:</strong><br><a href="' + d.meeting_url + '" target="_blank" style="word-break:break-all;">' + d.meeting_url + '</a></p>' +
										'<p class="celara-redirect-popup__redirect-msg">Debug mode — redirect disabled.</p>'
										: '<p class="celara-redirect-popup__redirect-msg">Redirecting to Qualiphy in <span id="celara-countdown">5</span>s…</p>'
									) +
									'</div>';
								document.body.appendChild(overlay);
							}

							if (CELARA_DEBUG_MEDICAL) {
								btn.innerHTML = originalText;
								btn.style.pointerEvents = '';
								btn.style.opacity = '';
							} else if (CELARA_SHOW_POPUP) {
								var seconds = 5;
								var countdownEl = document.getElementById('celara-countdown');
								var timer = setInterval(function () {
									seconds--;
									if (countdownEl) countdownEl.textContent = seconds;
									if (seconds <= 0) {
										clearInterval(timer);
										window.location.href = d.meeting_url;
									}
								}, 1000);
							} else {
								window.location.href = d.meeting_url;
							}

						} else {
							alert(data.data || 'Failed to start medical review. Please try again.');
							btn.innerHTML = originalText;
							btn.style.pointerEvents = '';
							btn.style.opacity = '';
						}
					})
					.catch(function () {
						alert('Network error. Please try again.');
						btn.innerHTML = originalText;
						btn.style.pointerEvents = '';
						btn.style.opacity = '';
					});
			});
		});
	});
})();


// ==============================
// Other pages
// ==============================
$(document).ready(function () {

	$('.site-loader-js').addClass('is-hidden');

	function openSideBar() {
		$(".open-sidebar_nav-js").addClass("active");
		$(".header_hamburger-wrapper-js").addClass("active");
		$(".sidebar_nav-js").addClass("active");
		$(".sidebar_nav-overlay-js").addClass("active");
		$('body').addClass("overflow-hidden");
	}

	function closeSideBar() {
		$(".open-sidebar_nav-js").removeClass("active");
		$(".header_hamburger-wrapper-js").removeClass("active");
		$(".sidebar_nav-js").removeClass("active");
		$(".sidebar_nav-overlay-js").removeClass("active");
		$('body').removeClass("overflow-hidden");
	}

	$(".open-sidebar_nav-js").on("click", openSideBar);
	$(".close-sidebar_nav-js").on("click", closeSideBar);
	$(".sidebar_nav-overlay-js").on("click", closeSideBar);

	$(window).on("resize", function () {
		if ($(window).width() > 991) {
			closeSideBar();
		}
	});


	if ($('.home_banner-swiper-js').length > 0) {
		new Swiper(".home_banner-swiper-js", {
			slidesPerView: 1,
			spaceBetween: 16,

			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},

			breakpoints: {
				320: {
					slidesPerView: 1.5,
					spaceBetween: 10,
				},
				460: {
					slidesPerView: 2.25,
					spaceBetween: 10,
				},
				560: {
					slidesPerView: 3.25,
					spaceBetween: 10,
				},
				768: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
				880: {
					slidesPerView: 4.5,
					spaceBetween: 10,
				},
				992: {
					slidesPerView: 5,
					spaceBetween: 10,
				},
				1280: {
					slidesPerView: 6,
					spaceBetween: 10,
				},
			}
		});
	}

	if ($('.our_community-swiper-js').length > 0) {
		new Swiper(".our_community-swiper-js", {
			slidesPerView: 1,
			spaceBetween: 16,

			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},

			breakpoints: {
				1280: {
					slidesPerView: 1.5,
					spaceBetween: 24,
				},
			}
		});
	}

	if ($('.our_client-swiper-js').length > 0) {
		new Swiper(".our_client-swiper-js", {
			slidesPerView: 1,
			spaceBetween: 16,

			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				dynamicBullets: true,
			},
			breakpoints: {
				992: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			}
		});
	}

	// PDP Related Products Swiper
	if ($('.pdp-related-swiper-js').length > 0) {
		new Swiper(".pdp-related-swiper-js", {
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 12,
				},
			}
		});
	}

	// Steps
	if ($('.step_wrapper-js').length > 0) {
		$('.step_item-wrapper-js').on('click', function () {
			const tab = $(this).data('tab_step');
			// console.log('tab: ', tab);

			$(".step_item-wrapper-js").removeClass("active");
			$(this).addClass("active");

			$(`.step_content-wrapper-js`).removeClass("active");
			$(`.step_content-wrapper-js[data-content_step='${tab}']`).addClass("active");
		})
	}

	// Account swiper
	if ($('.my_account-swiper-js').length > 0) {
		new Swiper(".my_account-swiper-js", {
			slidesPerView: 1,
			spaceBetween: 16,

			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				992: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
			}
		});
	}
});
